module.exports = __webpack_public_path__ + "img/Left Screenshot.d53dc499.png";